/**
 * Restricts user to enter except alpha charactors
 *
 * @param {object} event entered key object
 * @returns boolean
 * @memberof PersonalInformationComponent
 */
// export const textValidator = (event: any) => {
//   const key = event.keyCode;
//   return (
//     (key >= 65 && key <= 90) ||
//     key == 8 ||
//     key == 9 ||
//     key == 37 ||
//     key == 39 ||
//     key === 32
//   );
// };

/**
 *
 * Restricts user to enter except numbers
 * @param {object} event entered key object
 * @returns boolean
 * @memberof PersonalInformationComponent
 */
// export const numericValidator = (event: any) => {
//   const key = event.which ? event.which : event.keyCode;
//   if (
//     event.keyCode == 8 ||
//     event.keyCode == 46 ||
//     event.keyCode == 37 ||
//     event.keyCode == 39
//   ) {
//     return true;
//   } else if (key < 48 || (key > 57 && key < 96) || key > 105) {
//     return false;
//   } else return true;
//   // var charCode = event.which ? event.which : event.keyCode;
//   // if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
//   // return true;
// };

/**
 *
 * Restricts user to enter except numbers
 * @param {object} event entered key object
 * @returns boolean
 * @memberof PersonalInformationComponent
 */
// export const numericFloatValidator = (event: any) => {
//   const charCode = event.which ? event.which : event.keyCode;
//   if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
//     return false;

//   return true;
// };

// export const removeDuplicates = (myArr: any, prop: any) => {
//   return myArr.filter((obj: any, pos: any, arr: any) => {
//     return arr.map((mapObj: any) => mapObj[prop]).indexOf(obj[prop]) === pos;
//   });
// };

// export const getHeader = (table: any) => {
//   const headers: string[] = [];
//   if (table) {
//     table.forEach((value: any) => {
//       Object.keys(value).forEach((key) => {
//         if (!headers.find((header) => header == key)) {
//           headers.push(key);
//         }
//       });
//     });
//   }
//   return headers;
// };

export function getColorForName(name: string): string {
  const colorMap: Record<string, string> = {
    A: "#ffd8d0",
    B: "#EAF4FF",
    C: "#d0d8ff",
    D: "#ffd0ea",
    E: "#D2B5EA",
    F: "#ffe2d0",
    G: "#e5d0ff",
    H: "#d0ffe7",
    I: "#fff2d0",
    J: "#d0dfff",
    K: "#ffd0e4",
    L: "#FFF3CE",
    M: "#FCE8FE",
    N: "#d0ebff",
    O: "#CEFFF0",
    P: "#d0ffde",
    Q: "#ffe5d0",
    R: "#d5d5ff",
    S: "#ffd0f2",
    T: "#d0fff9",
    U: "#ffd8d0",
    V: "#d0ffd9",
    W: "#f2d0ff",
    X: "#ffdadf",
    Y: "#B7C5EF",
    Z: "#ffebd0",
  };

  const firstLetter = name.charAt(0).toUpperCase();
  return colorMap[firstLetter] || "#999999";
}

export function getTextColorForName(name: string): string {
  const colorMap: Record<string, string> = {
    A: "#FF5733",
    B: "#5BB1FE",
    C: "#3357FF",
    D: "#FF33A5",
    E: "#A233FF",
    F: "#FF8333",
    G: "#8D33FF",
    H: "#33FF95",
    I: "#FFC733",
    J: "#3373FF",
    K: "#FF3389",
    L: "#B1780D",
    M: "#A557A5",
    N: "#33A8FF",
    O: "#3F9979",
    P: "#33FF71",
    Q: "#FF8E33",
    R: "#4747FF",
    S: "#FF33C7",
    T: "#33FFE4",
    U: "#FF5733",
    V: "#33FF5A",
    W: "#C733FF",
    X: "#FF5F73",
    Y: "#1641C5",
    Z: "#FFA833",
  };

  const firstLetter = name.charAt(0).toUpperCase();
  return colorMap[firstLetter] || "#000000";
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function replaceString(template: string, ...values: any[]): string {
  return template.replace(/{(\d+)}/g, (match, index) => {
    return typeof values[index] !== "undefined" ? values[index] : match;
  });
}
/* eslint-enable @typescript-eslint/no-explicit-any */

/// To Do Need to uncomment all global functions with migration progress
